module.exports = __webpack_public_path__ + "img/tuscaloosa-tourism-logo.01edfbe2.jpg";